<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Upload Image
</h1>

<form>
    <div mat-dialog-content
         class="mat-dialog-content-div">
        <div>
            <span>File: </span>
            <span class="filename-span">{{this.SelectedFileName}}</span>
        </div>
    </div>

    <div class="icon-file-div">
        <input type="file"
               #selectIconFile
               accept=".png,.jpg"
               class="hidden-file-input"
               (change)="this.onIconFileChanged($event)" />

        <button mat-flat-button
                color="accent"
                (click)="this.loadIconFileClicked()"
                class="select-icon-button">
            Select Image ...
        </button>
    </div>

    <div class="icon-name-div">
        <span>Icon Name:</span>
        <input matInput
               type="text"
               name="iconName"
               [(ngModel)]="this.IconName"
               (ngModelChange)="this.iconNameChanged()"
               placeholder="Please enter a name"
               class="icon-name-mat-input" />

    </div>

    <div class="upload-status-div">
        <span>Status:</span><span class="upload-status-span">{{this.UploadStatus}}</span>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(!this.IconFileSelected) || (this.IconName == '') || this.IconUploading || (this.UploadStatus != '')"
                (click)="this.uploadIcon()">
            Upload ...
        </button>

        <button mat-flat-button
                [disabled]="this.IconUploading"
                style="margin-left: 10px;"
                (click)="this.cancelClicked()">
            Close
        </button>
    </div>
</form>
